/**
 * CU - Contact Us
 * SH - Search Help tab
 * RC - Request Creation tab
 * RH - Request History tab
 * RD - Request details
 * RH-Card - Request Card
 */
export class AutomationIds {
  /** common */
  public static NavigationTab = 'CU-Navigation-Tab';
  /**
   * Search help ids
   */
  public static SearchHelpTab = 'CU-SH-Tab';
  public static SearchHelpInput = 'CU-SH-Input';
  public static GetHelpBtn = 'CU-SH-GetHelp';
  public static BCQRSolutionsTitle = 'CU-SH-BCQRTitle';
  public static AutoSuggestOptions = 'CU-SH-AutoSuggestOptions';
  public static AutoSuggestOption = 'CU-SH-AutoSuggestOption';
  public static AutoSuggestCardLinkIcon = 'CU-SH-AutoSuggestCardLinkIcon';
  public static AutoSuggestCardLink = 'CU-SH-AutoSuggestCardLink';
  public static IntentGraph = 'CU-SH-IntentGraph';
  public static Insights = 'CU-SH-Insights';
  public static Solutions = 'CU-SH-Solutions';
  public static InsightDescription = 'CU-SH-InsightDescription';
  public static SolutionsDescription = 'CU-SH-SolutionsDescription';
  public static AutoSuggestNodeBranch = 'CU-SH-NodeBranch';
  public static RecommendedArticleBranch = 'CU-SH-RecommendedArticle';
  /**
   * Request Creation tab ids
   */
  public static RequestCreationTab = 'CU-RC-Tab';
  public static RequestCreationContent = 'CU-RC-Content';
  /**
   * Request History  ids
   */
  public static RequestHistoryTab = 'CU-RH-Tab';
  /**
   * Request Card  ids
   */
  public static RequestCard = 'CU-RH-Card';
  public static NonAgentModalityRedirectURL = 'CU-NonAgentModality-RedirectURL';
  /**
   * Attachments ids
   */
  public static Attachments = 'CU-Attachments';
  public static RequestAttachmentInput = 'CU-Common-AttachmentInput';
  public static RequestAttachmentName = 'CU-Common-AttachmentName';
  public static RequestAttachment = 'CU-Common-Attachment';
  public static RequestDownloadAttachment = 'CU-Common-DownloadAttachment';
  public static RequestDeleteAttachment = 'CU-Common-DeleteAttachment';
  public static RequestUploadAttachment = 'CU-Common-UploadAttachment';
  public static RequestCancelUploadAttachment = 'CU-Common-CancelUploadAttachment';
  /**
   * Request Status ids
   */
  public static RequestStatusCard = 'NH-RD-RequestStatusCard';
  public static RequestStatusChatBtn = 'RD-Status-Chat-Btn';
  /**
   * Request Feedback ids
   */
  public static RequestFeedback = 'NH-RD-RequestFeedback';
  /**
   * Sticky Footer ids
   */
  public static GiveUsFeedbackBtn = 'CU-GiveUsFeedback-BTn';
  public static FooterContactUsBtn = 'FT-ContactUs-BTn';
  public static FooterSignInBtn = 'FT-SignIn-BTn';

  /**
   * Severity ids
   */
  public static BusinessImpactConfirmed = 'CU-BusinessImpactConfirmed';
  public static CustomerAvailabilityConfirmed = 'CustomerAvailabilityConfirmed';

  /**
   * Regional Settings ids
   */
  public static RegionalSettings = 'CU-RC-RegionalSettings';

  /**
   * Feedback Ids
   */
  public static FeedbackTooltip = 'CU-FB-FeedbackTooltip';
  public static FeedbackRating = 'CU-FB-FeedbackRating';
  public static AboutTooltip = 'CU-FB-AboutTooltip';

  public static AutoSuggestCallout = 'CU-SH-AutoSuggestCallout';

  /**
  * VSB Upsell ALert Ids
  */
  public static VSBUpsellAlert = 'CU-VSBUpsellAlert';
  public static VSBUpsellAlertCTAButton = 'CU-VSBUpsellAlertCTAButton';
}
